import { useCan } from './useCan'

export const useCanForFeatures = () => ({
  canManageOrganizationSetting: useCan(`manage-organization-setting`),
  canManageConnection: useCan(`manage-connection`),
  canManageEltModel: useCan(`manage-elt-model`),
  canManageGoal: useCan(`manage-goal`),
  canManageDimensionGroup: useCan(`manage-dimension-group`),
  canManageUsers: useCan(`manage-users`),
  canManageUserGroups: useCan(`manage-user-groups`),
  canManageInvitation: useCan(`manage-invitation`),
  canManagePolicy: useCan(`manage-policy`),
  canManageRecordVisibility: useCan(`manage-record-visibility`),
  canReadUserActivity: useCan(`read-user-activity`),
  // v1用の権限
  canManageKpi: useCan(`kpi-update`),
  canManageDashboard: useCan(`kpi-pivot-update`),
  // v2の仕様が微妙な箇所の権限
  canOpenKpi: useCan(`kpi-create`),
})
